import { useUpdateMaintenanceMutation, useGetMaintenanceQuery } from 'app/services/tools';
import MaintenanceForm from './Form';
import { ToolMaintenance } from 'app/types/tool';

const EditMaintenance = ({ maintenance }: { maintenance: ToolMaintenance }) => {
  const [ update, meta ] = useUpdateMaintenanceMutation();
  const { data: maintenanceHistory } = useGetMaintenanceQuery(maintenance.ToolId);

  const previousFilterSerialNumber = maintenanceHistory?.slice()
    .filter((m) => m.Id !== maintenance.Id)
    .sort((a, b) => new Date(b.ExecutedAt).getTime() - new Date(a.ExecutedAt).getTime())[0]?.FilterSerialNumber;

  const onSubmit = async (values: any) => {
    await update({ Id: maintenance.Id, ...values }).unwrap();
  };

  return <MaintenanceForm
    handleSubmit={onSubmit}
    meta={meta}
    maintenance={maintenance}
    previousFilterSerialNumber={previousFilterSerialNumber}
  />;
};

export default EditMaintenance;